const fr = {
  brand: "Offertli",
  nav: {
    dashboard: "Tableau de bord",
    customers: "Clients",
    requests: "Demandes",
    offers: "Offres",
    projects: "Projets",
    invoices: "Factures",
    catalog: "Stock",
    organization: "Organisation",
    users: "Utilisateurs",
    settings: "Paramètres",
    more: "Plus",
    newRequest: "Nouvelle demande",
    notifications: "Notifications",
    main: "Navigation principale",
  },
  userMenu: {
    label: "Menu utilisateur",
    language: "Langue",
    logout: "Se déconnecter",
  },
  theme: {
    label: "Apparence",
    system: "Système",
    light: "Clair",
    dark: "Sombre",
  },
  locale: {
    en: "English",
    de: "Deutsch",
    fr: "Français",
    es: "Español",
  },
  common: {
    save: "Enregistrer",
    cancel: "Annuler",
    back: "Retour",
    next: "Suivant",
    continue: "Continuer",
    submit: "Envoyer",
    close: "Fermer",
    loading: "Chargement…",
    retry: "Réessayer",
    yes: "Oui",
    no: "Non",
    optional: "facultatif",
    required: "obligatoire",
    add: "Ajouter",
    remove: "Supprimer",
    edit: "Modifier",
    delete: "Supprimer",
    email: "E-mail",
    password: "Mot de passe",
    firstName: "Prénom",
    lastName: "Nom",
    phone: "Téléphone",
    website: "Site web",
    name: "Nom",
    stepOf: "Étape {{current}} sur {{total}}",
  },
  validation: {
    required: "Ce champ est obligatoire.",
    email: "Veuillez saisir une adresse e-mail valide.",
    minLength: "Doit contenir au moins {{min}} caractères.",
    maxLength: "Doit contenir au plus {{max}} caractères.",
    passwordMin: "Le mot de passe doit contenir au moins {{min}} caractères.",
    passwordMismatch: "Les mots de passe ne correspondent pas.",
    iban: "Veuillez saisir un IBAN valide.",
    qrIbanRequired: "Un IBAN-QR est requis pour les références QR (QRR).",
    termsRequired: "Vous devez accepter les conditions pour continuer.",
    rateRange: "Le taux doit être compris entre 0 et 100.",
    invalidNumber: "Veuillez saisir un nombre valide.",
    tokenRequired: "Veuillez saisir votre jeton de configuration.",
    minOneRate: "Au moins un taux de taxe est requis.",
    passwordLetter: "Le mot de passe doit contenir au moins une lettre.",
    passwordNumber: "Le mot de passe doit contenir au moins un chiffre.",
    passwordPolicy:
      "Utilisez au moins 10 caractères, dont une lettre et un chiffre.",
    localeUnsupported: "Sélectionnez l’une des langues proposées.",
    invalidDate: "Saisissez une date valide.",
    invalidTime: "Saisissez une heure valide.",
    endAfterStart: "L’heure de fin doit être postérieure à l’heure de début.",
    completeDateTime:
      "Saisissez à la fois une date et une heure au format 24 h (HH:mm).",
  },
  errors: {
    generic: "Une erreur est survenue. Veuillez réessayer.",
    invalidFields: "Vérifiez les champs signalés et corrigez les erreurs.",
    network: "Impossible de joindre le serveur. Vérifiez votre connexion.",
    sessionExpired: "Votre session a expiré. Veuillez vous reconnecter.",
    forbidden: "Vous n'avez pas l'autorisation d'accéder à cette page.",
    invalidCredentials: "E-mail ou mot de passe incorrect.",
    tooManyAttempts: "Trop de tentatives. Veuillez réessayer plus tard.",
  },
  forbidden: {
    title: "Accès refusé",
    message:
      "Votre compte ne dispose pas de l'autorisation requise pour afficher cette page.",
    backHome: "Retour au tableau de bord",
  },
  status: {
    draft: "Brouillon",
    submitted: "Soumise",
    in_process: "En cours",
    processed: "Traitée",
    ready: "Prête",
    sent: "Envoyée",
    accepted: "Acceptée",
    rejected: "Refusée",
    declined: "Refusée",
    planned: "Planifié",
    scheduled: "Programmé",
    in_progress: "En cours",
    on_hold: "En attente",
    completed: "Terminé",
    issued: "Émise",
    credited: "Créditée",
    unpaid: "Impayée",
    partially_paid: "Partiellement payée",
    paid: "Payée",
    overpaid: "Trop-payée",
    overdue: "Échue",
    low: "Basse",
    normal: "Normale",
    high: "Haute",
    invited: "Invité",
    active: "Actif",
    suspended: "Suspendu",
    deactivated: "Désactivé",
  },
  auth: {
    currentPassword: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe",
    login: {
      title: "Connexion",
      subtitle: "Connectez-vous à votre compte Offertli.",
      email: "E-mail",
      password: "Mot de passe",
      rememberMe: "Rester connecté",
      submit: "Se connecter",
      submitting: "Connexion en cours…",
      forgot: "Mot de passe oublié ?",
    },
    forgot: {
      title: "Réinitialiser le mot de passe",
      subtitle:
        "Saisissez votre adresse e-mail et nous vous enverrons un lien de réinitialisation.",
      submit: "Envoyer le lien",
      sentTitle: "Vérifiez votre boîte de réception",
      sentMessage:
        "Si un compte existe pour cette adresse e-mail, vous recevrez bientôt un lien de réinitialisation.",
      backToLogin: "Retour à la connexion",
    },
    reset: {
      title: "Choisir un nouveau mot de passe",
      subtitle: "Définissez un nouveau mot de passe pour votre compte.",
      newPassword: "Nouveau mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      submit: "Définir le mot de passe",
      successTitle: "Mot de passe mis à jour",
      successMessage:
        "Votre mot de passe a été modifié. Vous pouvez maintenant vous connecter.",
      missingToken: "Ce lien de réinitialisation est invalide ou a expiré.",
      toLogin: "Aller à la connexion",
    },
  },
  invite: {
    title: "Accepter l'invitation",
    subtitle:
      "Bienvenue sur Offertli. Définissez votre mot de passe pour activer votre compte.",
    invitedAs: "Vous avez été invité en tant que",
    email: "E-mail",
    password: "Mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    acceptTerms:
      "J'accepte les conditions d'utilisation et la déclaration de confidentialité.",
    submit: "Activer le compte",
    invalidTitle: "Invitation invalide",
    invalidMessage:
      "Ce lien d'invitation est invalide, a expiré ou a déjà été utilisé.",
    toLogin: "Aller à la connexion",
  },
  setup: {
    title: "Configurer Offertli",
    subtitle: "Configurez votre entreprise en quelques étapes.",
    alreadyDone: "La configuration est déjà terminée.",
    steps: {
      credential: "Accès",
      language: "Langue",
      industry: "Secteur",
      company: "Entreprise",
      address: "Adresse",
      branding: "Image de marque",
      systemAdmin: "Administrateur système",
      localization: "Localisation",
      vat: "TVA",
      bank: "Banque & QR-facture",
      numbering: "Numérotation",
      review: "Vérification",
    },
    credential: {
      title: "Vérifier l'accès",
      description:
        "Saisissez le jeton de configuration de votre serveur ou ouvrez le lien d'invitation reçu par e-mail.",
      tokenLabel: "Jeton de configuration",
      tokenHint:
        "Vous trouverez le jeton dans votre environnement de déploiement (OFFERTLI_SETUP_TOKEN).",
      validate: "Valider le jeton",
      validating: "Validation en cours…",
      invalid: "Ce jeton est invalide ou la configuration est déjà terminée.",
      inviteDetected: "Lien d'invitation détecté",
      inviteValid: "Invitation pour {{email}} vérifiée.",
      inviteInvalid: "Ce lien d'invitation est invalide ou a expiré.",
      useToken: "Utiliser un jeton de configuration",
    },
    language: {
      title: "Langue de l'interface",
      description:
        "Choisissez la langue de cet assistant et de votre propre interface.",
    },
    industry: {
      label: "Secteur d’activité",
      description:
        "Choisissez le secteur qui correspond le mieux à votre entreprise. Nous préparerons des catégories par défaut adaptées.",
      options: {
        landscaping: "Paysagisme",
        general_services: "Services généraux",
        construction: "Construction",
        cleaning: "Nettoyage",
        other: "Autre",
      },
    },
    company: {
      title: "Identité de l'entreprise",
      name: "Raison sociale",
      tradingName: "Nom commercial",
      vatNumber: "Numéro TVA / IDE",
      website: "Site web",
    },
    address: {
      title: "Adresse & contact",
      line1: "Adresse ligne 1",
      line2: "Adresse ligne 2",
      postalCode: "NPA",
      city: "Localité",
      canton: "Canton / région",
      country: "Pays",
      email: "E-mail de l'entreprise",
      phone: "Téléphone",
    },
    systemAdmin: {
      title: "Administrateur système",
      description:
        "Définissez le mot de passe de l’administrateur système intégré. Aucun compte employé ou utilisateur n’est créé.",
      username: "Nom d’utilisateur",
    },
    localization: {
      title: "Langue, fuseau horaire & devise",
      locale: "Langue par défaut",
      localeHint:
        "Utilisée pour les nouveaux utilisateurs et documents sans préférence définie.",
      timezone: "Fuseau horaire",
      currency: "Devise",
    },
    vat: {
      title: "TVA & taux de taxe",
      registered: "Assujetti à la TVA",
      registeredHint: "Activez si votre entreprise est enregistrée à la TVA.",
      rates: "Taux de taxe",
      ratesHint:
        "Définissez les taux de TVA disponibles sur les offres et factures.",
      rateName: "Nom du taux",
      rateValue: "Taux (%)",
      isDefault: "Par défaut",
      addRate: "Ajouter un taux",
      standardRate: "Taux normal",
      noVat: "Pas de TVA",
    },
    bank: {
      title: "Banque & QR-facture",
      description: "Utilisé pour générer les QR-factures suisses.",
      iban: "IBAN",
      ibanHint: "L'IBAN sur lequel les paiements doivent arriver.",
      qrIbanHint: "Les références QRR exigent un IBAN-QR (QR-IID 30000–31999).",
      bankName: "Banque",
      referenceType: "Type de référence",
      refNON: "Sans référence (NON)",
      refSCOR: "Référence créancier (SCOR)",
      refQRR: "Référence QR (QRR)",
      paymentTermDays: "Délai de paiement (jours)",
    },
    numbering: {
      title: "Numérotation & valeurs par défaut",
      description:
        "Les numéros de documents sont générés automatiquement. Vous pourrez ajuster les préfixes et formats plus tard dans les paramètres.",
      paymentTermDays: "Délai de paiement (jours)",
      offerValidityDays: "Validité des offres (jours)",
      previewTitle: "Formats de numérotation par défaut",
      customer: "Client",
      request: "Demande",
      offer: "Offre",
      project: "Projet",
      invoice: "Facture",
    },
    review: {
      title: "Vérifier & terminer",
      description: "Vérifiez votre configuration avant de terminer.",
      companySection: "Entreprise",
      systemAdminSection: "Administrateur système",
      localizationSection: "Localisation",
      billingSection: "Facturation",
      documentsSection: "Documents",
      complete: "Terminer la configuration",
      completing: "Finalisation…",
      failed:
        "La configuration n'a pas pu être terminée. Veuillez vérifier vos saisies.",
    },
  },
  dashboard: {
    title: "Tableau de bord",
    welcome: "Bon retour, {{name}}.",
    placeholderTitle: "Votre tableau de bord est en préparation",
    placeholderMessage:
      "Les widgets pour les demandes, offres et factures ouvertes apparaîtront ici dans la prochaine itération.",
  },
  notifications: {
    title: "Notifications",
    empty: "Aucune nouvelle notification",
  },
  notFound: {
    title: "Page introuvable",
    message: "La page que vous cherchez n'existe pas ou a été déplacée.",
    backHome: "Retour au tableau de bord",
  },
  offline: {
    title: "Vous êtes hors ligne",
    message:
      "Offertli a besoin d'une connexion au serveur. Vérifiez votre réseau et réessayez.",
    retry: "Réessayer",
  },
} as const;

export default fr;
